import Rest from '../rest';
import APPLICATION_CONSTANTS from '../applicationConstants';

/**
 * Represents the tenant service.
 */
class TenantService {
  /**
   * Creates a new Salesforce lead for an appointment.
   * @param {Object} payload The payload.
   * @returns Promise
   */
  createAppointmentSalesforceLead(payload) {
    return new Promise((resolve, reject) => {
      const url = `${APPLICATION_CONSTANTS.GLOBAL.API_URL}/Tenant/CreateSalesforceLead`;
      Rest.post(url, payload, { timeout: APPLICATION_CONSTANTS.GLOBAL.API_TIMEOUT })
        .then(res => resolve(res?.data))
        .catch(error => reject(error));
    });
  }
  
  /**
   * Gets the current tenant specific configuration options.
   * @returns Promise
   */
  getTenantUIOptions() {
    return new Promise((resolve, reject) => {
      const url = `${process.env.LOCATOR_API}/tenant/getUiConfiguration/${APPLICATION_CONSTANTS.GLOBAL.CURRENT_TENANT}`;
      
      Rest.get(url)
        .then(res => resolve(res?.data))
        .catch(error => reject(error));
    });  
  }
}

export default TenantService;
